module.exports = __webpack_public_path__ + "img/mickys_headphones.f40a7837.jpg";